import { styled } from 'styled-components';

const MobileCashBackHistory = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 0;
  gap: 12px;
  flex-grow: 1;
`;

const HistoryButtonDesktopContainer = styled.div`
  display: flex;
  justify-items: flex-end;
  align-items: center;
  width: 100%;

  padding: 30px 0;
  justify-content: flex-end;
  gap: 10px;
  // align-self: stretch;
`;
const HistoryButtonDesktop = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 10px 8px 8px;
  align-items: center;
  gap: 8px;

  overflow: hidden;
  color: #fff;
  text-overflow: ellipsis;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  cursor: pointer
`;
const HistoryButtonDesktopImg = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  background-image: url('/images/cashback/icons/clock.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;
const ButtonText = styled.div`
  color: var(--edeff-5, #edeff5);
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  @media (min-width: 769px) {
    font-size: 16px;
  }
`;
 const RootContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background: #131315;
  @media (min-width: 769px) {
    margin: 30px 0 60px;
    gap: 30px;
  }
`;
 const Wrapper = styled.div`
  max-width: 1132px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 768px) {
    width: calc(100% - 36px);
  }
`;
const AuthButtonsBleed = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    width: calc(100% + 36px);
    margin-left: -18px;
  }
`;
const ExpiryBox = styled.div`
  border-radius: 8px;
  border: 2px solid #4b4b4b;
  padding: 18px 12px;
  width: 100%;
  display: flex;
  flex: 1;
  gap: 20px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;


export {
  ButtonText,
  HistoryButtonDesktop,
  HistoryButtonDesktopContainer,
  HistoryButtonDesktopImg,
  MobileCashBackHistory,
  RootContainer,
  Wrapper,
  ExpiryBox,
  AuthButtonsBleed
  };